import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Gamepad2, FolderTree, Image, Users, BarChart3, LogOut, Menu, X,MessageSquare,HeadphonesIcon, Bell } from 'lucide-react';

const Layout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/categories', icon: FolderTree, label: 'Game Categories' },
    { path: '/games', icon: Gamepad2, label: 'Games' },
    { path: '/wallpaper-categories', icon: FolderTree, label: 'Wallpaper Categories' },
    { path: '/wallpapers', icon: Image, label: 'Wallpapers' },
    { path: '/users', icon: Users, label: 'Users' },
    { path: '/chat', icon: MessageSquare, label: 'Chat' },
    { path: '/support', icon: HeadphonesIcon, label: 'Support' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-dark flex">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-20'} bg-dark-card border-r border-gray-800 transition-all duration-300 flex flex-col`}>
        <div className="p-6 flex items-center justify-between">
          {sidebarOpen && <h1 className="text-2xl font-bold gradient-primary bg-clip-text text-white">FunPlus</h1>}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-2 hover:bg-gray-800 rounded-lg">
            {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        <nav className="flex-1 px-4 space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                  isActive
                    ? 'gradient-primary text-white'
                    : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                }`}
              >
                <Icon size={20} />
                {sidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-800">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 text-gray-400 hover:bg-gray-800 hover:text-red-400 rounded-lg transition-all"
          >
            <LogOut size={20} />
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <header className="bg-dark-card border-b border-gray-800 px-8 py-4">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold">Welcome back, {user?.username}!</h2>
            <div className="flex items-center gap-4">
              <div
                  onClick={() => navigate('/notifications')}
                  className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center font-bold cursor-pointer"
                >
                  <Bell className="text-white" size={24} />
                </div>
              <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center font-bold">
                {user?.username?.charAt(0).toUpperCase()}
              </div>
              
            </div>
          </div>
        </header>
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;